export const FRONTEND_VERSION = '1.2.95';
